const now = () => (Math.floor(Date.now() / 1000));

const yesterday = () => (Math.floor(Date.now() / 1000) - 60 * 60 * 24);

export {
  now,
  yesterday,
};
